:host {
  display: block;
  object-fit: contain;
}

img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: inherit;
  object-position: inherit;
}